import { DateTime } from 'luxon'
import isPresent from './is-present'

export function isMultiDayEvent(event) {
  if (!isPresent(event.endAt)) {
    return false
  }

  const startAt = DateTime.fromISO(event.startAt, { setZone: true })
  const endAt = DateTime.fromISO(event.endAt, { setZone: true })

  return startAt.day !== endAt.day
}
